import React from 'react';
import { LanguageProvider } from './components/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { MeetCenia } from './components/MeetCenia';
import { Stats } from './components/Stats';
import { Services } from './components/Services';
import { Properties } from './components/Properties';
import { Neighborhoods } from './components/Neighborhoods';
import { Testimonials } from './components/Testimonials';
import { WorkWithCenia } from './components/WorkWithCenia';
import { Contact } from './components/Contact';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingButtons } from './components/FloatingButtons';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-white text-[#1a1a1a] font-sans overflow-x-hidden" data-id="element-1">
        <Navbar data-id="element-2" />

        <main data-id="element-3">
          <Hero data-id="element-4" />
          <Marquee data-id="element-5" />
          <MeetCenia data-id="element-6" />
          <Stats data-id="element-7" />
          <Services data-id="element-8" />
          <Properties data-id="element-9" />
          <Neighborhoods data-id="element-10" />
          <Testimonials data-id="element-11" />
          <WorkWithCenia data-id="element-12" />
          <FAQ data-id="element-13" />
          <Contact data-id="element-14" />
        </main>

        <Footer data-id="element-15" />
        <FloatingButtons data-id="element-16" />
      </div>
    </LanguageProvider>;
}